/* ==========================================================================
   ZOMBIE SNACKS — FOOTER END SCENE: replayable entrance (Phase 2C)
   Scoped to <zombie-end-scene> (sections/zombie-footer-end-scene.liquid).

   Taiga's component-animations.js marks every section with a permanent
   `section-anim-in` class and toggles `section-in-view` at a 0px threshold,
   so it cannot replay an entrance without flicker. This element keeps its
   own IntersectionObserver with hysteresis:
     - ENTER: add `is-active` once at least 25% of the scene is visible
       (the CSS transitions run from the start state to the resting state)
     - RESET: remove `is-active` only when the scene is fully out of the
       viewport again (0px visible); the CSS snaps back to the start state
       with no transition, so the next entry replays from the beginning
     - between 0% and 25% nothing changes, so hovering around the threshold
       never toggles the class
   Reduced motion: no observer, the scene is marked active immediately and
   the CSS shows the resting composition with no motion.
   No global scroll listener. Nothing outside this element is touched.
   ========================================================================== */
(function () {
  if (customElements.get('zombie-end-scene')) return;

  const ENTER_RATIO = 0.25;

  class ZombieEndScene extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('zombie-end-scene--motion')) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion || !('IntersectionObserver' in window)) {
        this.classList.add('is-active');
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= ENTER_RATIO) {
            this.classList.add('is-active');
          } else if (!entry.isIntersecting) {
            this.classList.remove('is-active');
          }
        });
      }, { threshold: [0, ENTER_RATIO] });

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('zombie-end-scene', ZombieEndScene);
})();
